import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { string, func, shape, object } from 'prop-types'
import { translate } from 'react-i18next'
import { PagesPaths } from '../../constants/Pages'
import { stores } from '../../stores'
import { ProfilePicture } from '../ui/ProfilePicture'
import { NewInquiryButton } from '../ui/buttons/NewInquiryButton'

class AuthenticatedComponent extends Component {
  constructor () {
    super()
    this.state = { dropdown: false }
    this.onDocumentClick = this.onDocumentClick.bind(this)
  }

  componentDidMount () {
    document.addEventListener('click', this.onDocumentClick)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.onDocumentClick)
  }

  onDocumentClick (event) {
    if (this.state.dropdown && this.node && !this.node.contains(event.target)) {
      this.setState({ dropdown: false })
    }
  }

  toggleDropdown () {
    this.setState({ dropdown: !this.state.dropdown })
  }

  closeDropdown () {
    this.setState({ dropdown: false })
    this.props.closeMenu()
  }

  logout () {
    stores.authentication.logout()
    this.props.history.go(PagesPaths.SIGNIN.path)
  }

  render () {
    const {
      account,
      t
    } = this.props
    const connected = account.connected
    const interventionDate = account.interventionDate

    return (
      <ul className='nav__list' ref={(node) => { this.node = node }}>
        <li className={'nav__item nav__item--dropdown'}>
          <button onClick={() => this.toggleDropdown()} className='nav__link nav__link--profile'
            aria-label={t('nav:account')} title={t('nav:account')}>
            <span className='profile-pill__lines' aria-hidden='true'><span /><span /><span /></span>
            <ProfilePicture className='nav__item__profile' rounded picture={connected ? connected.profilePicture : null} />
          </button>
        </li>
        <ul className={'dropdown ' + (this.state.dropdown ? 'active' : '')} >
          <li className='dropdown__item--cta'>
            <NewInquiryButton variant='menu' onNavigate={() => this.closeDropdown()} />
          </li>
          <li className='dropdown__item dropdown__item'>
            <Link onClick={() => this.closeDropdown()} className='dropdown__link' to='/demandes?type=demandes&page=0'>
              <div>
                <p className='dropdown__text'>{t('nav:visits')}</p>
                {
                  interventionDate && interventionDate.date
                  ? (
                    <p className='dropdown__text dropdown__text--small'>
                      Prochaine date d'intervention le {interventionDate.date} à {interventionDate.hours}
                    </p>)
                  : ''
                }
              </div>
            </Link>
          </li>
          <li className='dropdown__item'>
            <Link onClick={() => this.closeDropdown()} className='dropdown__link' to={PagesPaths.ACCOUNT.path}>
              <span className='dropdown__text'>{t('nav:infos')}</span>
            </Link>
          </li>
          <li className='dropdown__item dropdown__item--noborder'>
            <a className='dropdown__link' onClick={() => this.logout()}>
              <span className='dropdown__text'>{t('nav:logout')}</span>
            </a>
          </li>
        </ul>
      </ul>
    )
  }
}

AuthenticatedComponent.propTypes = {
  account: object,
  interventionDate: shape({
    date: string,
    hours: string
  }),
  history: object,
  closeMenu: func,
  t: func
}

export const Authenticated = withRouter(translate()(AuthenticatedComponent))



// WEBPACK FOOTER //
// ./src/components/header/Authenticated.js